import { Button, Grid } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { observer } from "mobx-react";
import React, { memo, useState } from "react";
import { Search } from "@material-ui/icons";
import { pagingDepartment } from "app/services/DepartmentService";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
const SearchCheckIn = ({ isOpenFillter }) => {
  return (
    <>
      {!isOpenFillter && (
        <>
          <style>
            {`
            @keyframes slideDownFade {
              0% {
                opacity: 0;
                transform: translateY(-10px);
              }
              100% {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}
          </style>
          <div
            style={{
              animation: "slideDownFade 0.3s ease forwards",
              zIndex: 10,
              position: "relative",
            }}
          >
            <Grid container spacing={1} className="cards-body">
              <Grid item xs={12} sm={6} md={4}>
                 <GlobitsMultiDatePicker 
                  label="Từ ngày - đến ngày" 
                  name="fromDate"
                  range
                  rangeHover
                  fromField="fromDate"
                  toField="toDate"
                  // format={"DD/MM/YYYY"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <GlobitsPagingAutocomplete
                  name={"departmentId"}
                  label={"Cơ sở"}
                  api={pagingDepartment}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="flex flex-end gap-2">
                <Button className="btn-primary" type="submit">
                  <Search />
                  Tìm kiếm
                </Button>
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

export default memo(observer(SearchCheckIn));
